__webpack_require__.p = "https://fantasygolf-preprod.pgatour.com/";